import { CarrierCapacityInfoDto } from "models/dto/CarrierCapacityInfoDto";
import { Icon, Popup, Table } from "semantic-ui-react";

import { formatDateForMatchRow } from "./CarrierCapacityShipmentMatchTableRow";
import { Option } from "models/Option";

import styles from "./CarrierCapacityShipmentMatchTable.module.scss";

export const shipmentMatchColSpan = 10;

type CarrierCapacityShipmentMatchCapacityTableRowProps<
  T extends "Capacity" | "Preferred Lane",
> = {
  capacity: CarrierCapacityInfoDto<T>;
  equipmentOptions: Option<number>[];
  message?: string;
};

const CarrierCapacityShipmentMatchCapacityTableRow = <
  T extends "Capacity" | "Preferred Lane",
>(
  props: CarrierCapacityShipmentMatchCapacityTableRowProps<T>
) => {
  const equipmentName =
    props.equipmentOptions.find(
      (option) => option.value === props.capacity.equipmentModeCategoryId
    )?.text ?? "Unknown Equipment";
  const formattedCapacityRoute = `${props.capacity.origin ?? "Any Origin"} → ${props.capacity.destination ?? "Any Destination"}`;

  return (
    <Table.Row>
      <Table.Cell
        colSpan={shipmentMatchColSpan}
        className={styles.capacityCell}
      >
        <Popup
          offset={[-10, 0]}
          wide="very"
          trigger={
            <Icon circular inverted name="info" size="small" color="blue" />
          }
        >
          <Popup.Header>{props.capacity.type} Information</Popup.Header>
          <Popup.Content>
            {props.capacity.type === "Capacity" &&
            props.capacity.availabilityDate ? (
              <div>
                {formatDateForMatchRow({
                  dateString: props.capacity.availabilityDate,
                  timeZone: "UTC",
                  includeTime: false,
                })}
              </div>
            ) : null}
            <div>{equipmentName}</div>
            <div>{formattedCapacityRoute}</div>
            {props.capacity.notes ? <div>{props.capacity.notes}</div> : null}
          </Popup.Content>
        </Popup>
        {formattedCapacityRoute}
        {props.message ? ` - ${props.message}` : null}
      </Table.Cell>
    </Table.Row>
  );
};

export default CarrierCapacityShipmentMatchCapacityTableRow;
